"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const ContainerWithResponsiveCarousel = ({ elements }) => {
    const [slideVisible, setSlideVisible] = react_1.useState('slide0');
    const carouselOnClick = (slide) => {
        var _a;
        (_a = document.getElementById(slide)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    const onScroll = (event) => {
        const widthPerSlide = event.currentTarget.scrollWidth / elements.length;
        const slideNr = event.currentTarget.scrollLeft / widthPerSlide;
        setSlideVisible(`slide${Math.floor(slideNr)}`);
    };
    return (React.createElement("div", { className: 'container-with-responsive-carousel-component' },
        React.createElement("div", { className: "container-with-responsive-carousel-content", onScroll: onScroll }, elements.map((element, index) => {
            return (React.createElement("div", { key: index, className: 'container-with-responsive-carousel-element', id: `slide${index}` }, element));
        })),
        React.createElement("div", { className: "container-with-responsive-carousel-dots" }, elements.map((e, index) => {
            const slideId = `slide${index}`;
            return (React.createElement("div", { key: index, className: `container-with-responsive-carousel-dot${slideId === slideVisible ? ' dot-selected' : ''}`, onClick: () => carouselOnClick(`slide${index}`) }));
        }))));
};
exports.default = ContainerWithResponsiveCarousel;
//# sourceMappingURL=ContainerWithResponsiveCarousel.js.map